// @sms/i18n — bilingual resource registry.
//
// Consumers do NOT import the JSON files directly; they call init(i18n) with
// the locale and namespace they want.  The shell wires this up via
// react-i18next in Phase 1.

import enCommon from "../locales/en/common.json";
import neCommon from "../locales/ne/common.json";

export type Locale = "ne" | "en";

export const resources = {
  en: { common: enCommon },
  ne: { common: neCommon },
} as const;

export const defaultLocale: Locale = "ne";
export const supportedLocales: readonly Locale[] = ["ne", "en"] as const;
